import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SendAnalyticsModule } from '@app/core/analytics/send-analytics/send-analytics.module';
import { TranslatePipe } from '@ngx-translate/core';
import { IconButtonComponent } from './icon-button.component';

@NgModule({
  imports: [CommonModule, MatIconModule, MatButtonModule, A11yModule, TranslatePipe, SendAnalyticsModule],
  declarations: [IconButtonComponent],
  exports: [IconButtonComponent]
})
export class IconButtonModule {}
